import APIs from "~/requests/APIs";
import liuReq from "~/requests/liu-req";
import {useGlobalStateStore} from "~/hooks/stores/useGlobalStateStore";
import wx from "weixin-js-sdk";

export const isInWx = ()=> {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes('micromessenger');
}
export const initWechatConfig = async () => {
    const url = APIs.GET_WX_CONFIG
    const gStore = useGlobalStateStore()
    const res = await liuReq.request<{
        appId: string,
        timestamp: number,
        nonceStr: string,
        signature: string
    }>(`${url}?url=${encodeURIComponent(window.location.href)}`, undefined,{method: "GET"})
    if(res.data){
        const {appId, timestamp, nonceStr, signature} = res.data || {}
        wx.config({
            // debug: true,
            appId,
            timestamp,
            nonceStr,
            signature,
            jsApiList: ['closeWindow'],
            openTagList: ['wx-open-subscribe']
        })
        wx.error((res) => {
            console.error('微信JS-SDK配置失败:', res)
            gStore.showWxSubscribeBtn = false
            gStore.wxReady = true
        })
        wx.ready(() => {
            console.log('微信JS-SDK配置完成')
            gStore.wxReady = true
        })

    }

}